import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesRevenueTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.revenue-trend",
  name: "Revenue trend",
  description: "A live revenue area chart with a dotted net-profit comparison line.",
  apps: [
    "appointments",
    "asset",
    "attendance",
    "configuration",
    "contracts",
    "crm",
    "document",
    "expenses",
    "field-service",
    "finance",
    "help-desk",
    "home",
    "hr",
    "integrations",
    "inventory",
    "invoicing",
    "maintanance",
    "manufacturing",
    "payroll",
    "point-of-sale",
    "procurement",
    "project",
    "recruitment",
    "rental",
    "sales",
    "schedule-planning",
    "subscriptions",
    "time-off",
    "timesheets",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "revenue",
          as: "revenue",
        },
      ],
    },
    graphQueries: [
      {
        name: "Revenue",
        query: {
          version: 1,
          source: "sales.analysis",
          ...period(30),
          select: [
            {
              type: "field",
              field: "order_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "revenue",
              as: "revenue",
            },
          ],
          group_by: [
            {
              field: "order_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.18,
      },
      {
        name: "Profit",
        query: {
          version: 1,
          source: "finance.journal-items",
          ...period(30),
          select: [
            {
              type: "field",
              field: "accounting_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "balance",
              as: "profit",
            },
          ],
          where: {
            type: "group",
            operator: "or",
            children: [
              {
                type: "condition",
                field: "account_type",
                operator: "starts_with",
                value: "income",
              },
              {
                type: "condition",
                field: "account_type",
                operator: "starts_with",
                value: "expense",
              },
            ],
          },
          group_by: [
            {
              field: "accounting_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "line",
        color: "#ae3ec9",
        lineWidth: 2,
        dashed: true,
        showMarkers: true,
      },
    ],
  },
  inputs: {
    title: "Revenue trend",
    valueFormat: "currency",
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$84,250",
    series: [
      18,
      24,
      20,
      32,
      36,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
